module.exports = __webpack_public_path__ + "img/9.59dc525c.jpg";